import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteClass = createAsyncThunk(
  'listClasses/fetchDeleteClass',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteClass(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteClassSlice = createSlice({
  name: 'classes/delete',
  initialState,
  reducers: {
    resetDeleteClass: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteClass.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteClass.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteClass.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteClassSlice.reducer
export const { resetDeleteClass } = deleteClassSlice.actions
